import 'reflect-metadata';
import { container } from "tsyringe";

import { Api } from './services/Api';
import { AppConfiguration } from './config/AppConfiguration';
import { UserService } from './services/UserService';
import { BusinessCaseService } from './services/BusinessCaseService';
import { NotificationService } from './services/NotificationService';

import { createApp } from 'vue';
import './registerServiceWorker';
import router from './router';
import '@progress/kendo-ui';
import '@progress/kendo-ui/js/cultures/kendo.culture.cs-CZ';
import '@progress/kendo-theme-default';
import "bootstrap/dist/js/bootstrap.min.js";

import { KendoInputsInstaller } from '@progress/kendo-inputs-vue-wrapper';

//Vue.use(KendoInputsInstaller);

kendo.culture('cs-CZ');

import config from './config/config.json';
import configLocal from './config/config.local.json';
import configDev from './config/config.dev.json';

import App from './App.vue';

// Import Bootstrap an BootstrapVue CSS files (order is important)
import './scss/app.scss';

const jQuery = require('jquery');

const isDev = process.env.NODE_ENV === 'development';
const isLocal = process.env.VUE_APP_IS_LOCAL == 1;
const isEnabledTwoFormFactorAuth = process.env.VUE_APP_2FA_ENABLED == 1;
// console.log('isDev:', isDev, 'isLocal:', isLocal, process.env);

const configuration: AppConfiguration = (isDev ? jQuery.extend({}, config, (isLocal ? configLocal : configDev)) : config);

const notificationService = new NotificationService(configuration.firebase);
const api = new Api(configuration.api);

// localStorage => token
let token = window.localStorage.getItem('token');
if(token) {
    api.token = token;
}

//container.registerInstance(AppConfiguration, configuration);
container.registerInstance(Api, api);
container.registerInstance(NotificationService, notificationService);

container.register(UserService, { useClass: UserService });
container.register(BusinessCaseService, { useClass: BusinessCaseService });


createApp(App).use(router).mount('#app');